import React, { useState } from 'react';
import QuickCustomerModal from '../../../Utils/QuickCustomerModal';
import FormInputs from '../../../Utils/FormInputs';

export default function NewQuickSalesReturn() {
  // initialProductRow
  const initialProductRow = {
    checkbox: false,
    serialNumber: '',
    description: '',
    unitPrice: '',
    qty: 0,
    disc: 0,
    dropdown: '',
    taxAmount: 0,
    total: 0
  }

  const [initialProductRows, setInitialProductRows] = useState(Array(5).fill({ ...initialProductRow }));

  const ProductColumnsConfig = [
    { label: 'S/N', field: 'serialNumber', type: 'autoIncrement' },
    { label: 'Description', field: 'description', type: 'text' },
    { label: 'Unit Price', field: 'unitPrice', type: 'number' },
    { label: 'Qty', field: 'qty', type: 'number' },
    { label: 'Disc', field: 'disc', type: 'number' },
    {
      label: 'Tax(%)',
      field: 'dropdown',
      type: 'select',
      defualt: 'None',
      options: [
        { value: 'gst', label: 'GST' },
        { value: 'cgst', label: 'CGST' },
        { value: 'igst', label: 'IGST' }
      ]
    },
    { label: 'Tax Amount', field: 'taxAmount', type: 'number' },
    { label: 'Total', field: 'total', type: 'number' }
  ];

  const handleAddRow = () => {
    const newRow = { ...initialProductRow }
    setInitialProductRows([...initialProductRows, newRow]);
  };

  // const [productsRows, setProductsRows] = useState([]);

  const handleProductChange = (index, field, value) => {
    const updatedRows = initialProductRows.map((row, i) => {
      if (i === index) {
        const updatedRow = { ...row, [field]: value };

        return updatedRow;
      } else {
        return row;
      }
    });
    setInitialProductRows(updatedRows);
  };

  // Add Customer modal
  const [customerModalShow, setCustomerModalShow] = useState(false);
  const handleShowCustomer = () => setCustomerModalShow(true);
  const handleCloseCustomer = () => setCustomerModalShow(false);

  const initialInputData = {
    invoice_number: '',
    customer_name: '',
    mobile_number: '',
    tax_name: '',
    sale_date: '',
    product_vendor: '',
    product_cost_price: '',
    product_quantity: '',
    amount_received: '',
    payment_type: '',
    total_unit_price: '',
    total_discount: '',
    c_gst: '',
    amount_due: '',
    taxable_amount: '',
    overall_discount: '',
    advancePayment: '',
    s_gst: '',
    amount_repaid: '',
    sub_total: '',
    total_item_discount: '',
    advance_payment_amount: '',
    total_tax_amount: '',
    grand_total: '',
    narration: '',
  }

  const [inputData, setInputData] = useState(initialInputData);
  const handleSalesInputChange = (index, field, value) => {
    setInputData({ ...inputData, [field]: value });
  };
  const handleSalesSubmit = (e) => {
    e.preventDefault();
  };
  const rows = [
    {
      columns: [
        { size: { sm: 3, md: 4, xl: 1 }, label: 'Number', type: 'text', placeholder: 'Enter pi no...', name: 'invoice_number', id: 'invoice_number', value: inputData.invoice_number, errormsg: '', },
        { size: { sm: 9, md: 8, xl: 4 }, label: 'Customer Name', type: 'inputwithbtn', placeholder: 'Enter customer name...', name: 'customer_name', id: 'customerName', value: inputData.customer_name, handleOnClick: handleShowCustomer, errormsg: '', },
        { size: { sm: 3, md: 4, xl: 2 }, label: 'Mobile Number', type: 'number', placeholder: '(+001) 1234 5678 90', name: 'mobile_number', id: 'mobileNumber', value: inputData.mobile_number, errormsg: '', },
        { size: { sm: 3, md: 4, xl: 3 }, label: 'Tax Name', type: 'text', placeholder: 'Tax name', name: 'tax_name', id: 'taxName', value: inputData.tax_name, errormsg: '', },
        { size: { sm: 3, md: 4, xl: 2 }, label: 'Sale Date', type: 'date', placeholder: 'DD/MM/YYYY', name: 'sale_date', id: 'saleDate', value: inputData.sale_date, errormsg: '', },
      ]
    },
    {
      columns: [
        {
          size: { md: 12 }, type: 'normaltextlist', ulclass: 'list-inline text-md-end text-muted fs-14 mb-2', liclass: 'list-inline-item ms-5 mb-2',
          listItems: [
            { listtext: 'GST No : 07AAGFF2194N1Z1' },
            { listtext: 'Advance Payment : 0' },
            { listtext: 'Wallet Balance : 0' },
          ],
        },
      ]
    },
    {
      columns: [
        { size: { md: 12 }, type: 'listview', initialProductRows: initialProductRows, ProductColumnsConfig: ProductColumnsConfig, handleAddRow: handleAddRow, handleProductChange: handleProductChange, },
      ]
    },
    {
      rowClass: 'mt-3',
      columns: [
        // First col data
        { size: { sm: 6, xl: 3 }, label: 'Product Vendor', type: 'text', placeholder: '', name: 'product_vendor', id: 'productVendor', value: inputData.product_vendor, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 3 }, label: 'Product Cost Price', type: 'text', placeholder: '', name: 'product_cost_price', id: 'productCostPrice', value: inputData.product_cost_price, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 3 }, label: 'Product Quantity', type: 'text', placeholder: '', name: 'product_quantity', id: 'productQuantity', value: inputData.product_quantity, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 3 }, label: 'Amount Received', type: 'text', placeholder: '', name: 'amount_received', id: 'amountReceived', value: inputData.amount_received, inputParentClass: 'custom-form-input-sm', errormsg: '', },

        // Second col data
        {
          size: { md: 6, xl: 2 }, label: 'Payment Type', type: 'select', name: 'payment_type', id: 'paymentType', value: inputData.payment_type, inputParentClass: 'custom-form-input-sm', errormsg: '',
          options: [
            { value: '', label: 'Select Payment Type' },
            // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
          ],
        },
        { size: { sm: 6, xl: 2 }, label: 'Total Unit Price', type: 'text', placeholder: '', name: 'total_unit_price', id: 'totalUnitPrice', value: inputData.total_unit_price, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 2 }, label: 'Total Discount', type: 'text', placeholder: '', name: 'total_discount', id: 'totalDiscount', value: inputData.total_discount, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 3 }, label: 'CGST', type: 'text', placeholder: '', name: 'c_gst', id: 'cGst', value: inputData.c_gst, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 3 }, label: 'Amount Due', type: 'text', placeholder: '', name: 'amount_due', id: 'amountDue', value: inputData.amount_due, inputParentClass: 'custom-form-input-sm', errormsg: '', },

        // Third col data
        { size: { sm: 6, xl: 2 }, label: 'Taxable Amount', type: 'text', placeholder: '', name: 'taxable_amount', id: 'taxableAmount', value: inputData.taxable_amount, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        {
          size: { md: 6, xl: 2 }, label: 'Discount', type: 'inputGroup', name: 'overall_discount', id: 'overallDiscount', value: inputData.overall_discount, inputParentClass: 'custom-form-input-sm', selectSize: 'sm', errormsg: '',
          options: [
            { value: '0', label: '% Off' }, { value: '1', label: 'Rs. Off' },
            // ...Tax && Tax.map((data) => ({ value: data.id, datataxrate: data.taxrate, label: data.name }))
          ],
        },
        { size: { sm: 6, xl: 2 }, label: 'Advance Payment', type: 'text', placeholder: '', name: 'advancePayment', id: 'advance_payment', value: inputData.advancePayment, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 3 }, label: 'SGST', type: 'text', placeholder: '', name: 's_gst', id: 'sGst', value: inputData.s_gst, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 3 }, label: 'Amount Repaid', type: 'text', placeholder: '', name: 'amount_repaid', id: 'amountRepaid', value: inputData.amount_repaid, inputParentClass: 'custom-form-input-sm', errormsg: '', },

        // Forth col data
        { size: { sm: 6, xl: 2 }, label: 'Sub Total', type: 'text', placeholder: '', name: 'sub_total', id: 'subTotal', value: inputData.sub_total, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 2 }, label: 'Total Item Discount', type: 'text', placeholder: '', name: 'total_item_discount', id: 'totalItemDiscount', value: inputData.total_item_discount, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 2 }, label: 'Advance Payment Amount', type: 'text', placeholder: '', name: 'advance_payment_amount', id: 'advancePaymentAmount', value: inputData.advance_payment_amount, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 3 }, label: 'Total Tax Amount', type: 'text', placeholder: '', name: 'total_tax_amount', id: 'totalTaxAmount', value: inputData.total_tax_amount, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        { size: { sm: 6, xl: 3 }, label: 'Grand Total', type: 'text', placeholder: '', name: 'grand_total', id: 'grandTotal', value: inputData.grand_total, inputParentClass: 'custom-form-input-sm', errormsg: '', },
      ]
    },
    {
      columns: [
        { size: { xl: 5, xxl: 6 }, label: 'Narration', type: 'text', placeholder: ' ', name: 'narration', id: 'narration', value: inputData.narration, inputParentClass: 'custom-form-input-sm', errormsg: '', },
        {
          size: { xl: 7, xxl: 6 }, type: 'button', additionalClass: 'justify-content-end mt-3',
          buttons: [
            { color: 'primary', id: 'GenerateAndNewSR', text: 'Generate and New SR' },
            { color: 'success', id: 'GenerateSalesReturn', text: 'Generate Sales Return' },
            { color: 'secondary', id: 'Cancel', text: 'Cancel' },
          ]
        },
      ]
    }
  ];
  const Buttons = [];

  return (
    <>
      {/* Form inputs */}
      <FormInputs Buttons={Buttons} rows={rows} handleInputChange={handleSalesInputChange} handleSubmit={handleSalesSubmit} />
      {/* Add Customer modal */}
      <QuickCustomerModal addCustomerShow={customerModalShow} addCustomerClose={handleCloseCustomer} />
    </>
  )
}
